<template>
  <div class="bidding-notice">
    <!-- 公告标题 -->
    <div class="notice-title">
      连云港石梁河水库采砂信息化监管平台升级改造项目公告
    </div>

    <!-- 发布时间 -->
    <div class="publish-time">
      <span class="tag info-tag medium-tag">发布时间：2025年11月10日</span>
    </div>

    <!-- 分隔线 -->
    <div class="divider"></div>

    <!-- 项目基本情况 -->
    <div class="notice-section">
      <div class="section-title">一、项目基本情况</div>
      <div class="desc-container">
        <div class="desc-item">
          <span class="desc-label">项目编号</span>
          <span class="desc-content">HHKJ20251110001</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">项目名称</span>
          <span class="desc-content">连云港石梁河水库采砂信息化监管平台升级改造项目</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">采购方式</span>
          <span class="desc-content">竞争性磋商</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">预算金额</span>
          <span class="desc-content">75万元</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">最高限价（如有）</span>
          <span class="desc-content">不超过总预算的100%。</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">采购需求</span>
          <span class="desc-content">连云港石梁河水库采砂信息化监管平台升级改造项目系统平台</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">合同履行期限</span>
          <span class="desc-content">合同签订之日起12个月</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">是否接受联合体</span>
          <span class="desc-content">否</span>
        </div>
      </div>
    </div>

    <!-- 申请人资格要求 -->
    <div class="notice-section">
      <div class="section-title">二、申请人的资格要求</div>
      <div class="qualification-list">
        <div class="qualification-subtitle">（一）满足《中华人民共和国政府采购法》第二十二条规定：</div>
        <ol class="basic-qualification">
          <li>法人或者其他组织的营业执照等证明文件，自然人的身份证明。</li>
          <li>上一年度的财务状况报告（成立不满一年不需提供）。</li>
          <li>依法缴纳税收和社会保障资金的相关材料。</li>
          <li>具备履行合同所必需的设备和专业技术能力的书面声明。</li>
          <li>参加政府采购活动前3年内在经营活动中没有重大违法记录的书面声明。</li>
        </ol>

        <div class="qualification-subtitle">（二）本项目的特定资格要求：</div>
        <ol class="specific-qualification" start="1">
          <li>未被“信用中国”网站（www.creditchina.gov.cn）列入失信被执行人、重大税收违法案件当事人名单、政府采购严重失信行为记录名单。</li>
        </ol>
      </div>
    </div>

    <!-- 获取采购文件 -->
    <div class="notice-section">
      <div class="section-title">三、获取采购文件</div>
      <div class="desc-container">
        <div class="desc-item">
          <span class="desc-label">获取时间</span>
          <span class="desc-content">自磋商文件公告发布之日起至2025.11.15下午17：30点（北京时间）</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">获取地点</span>
          <span class="desc-content">连云港经济技术开发区黄海大道58号</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">获取方式</span>
          <span class="desc-content">现场获取</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">文件售价</span>
          <span class="desc-content">0.00元</span>
        </div>
      </div>
    </div>

    <!-- 响应文件提交 -->
    <div class="notice-section">
      <div class="section-title">四、响应文件提交</div>
      <div class="desc-container">
        <div class="desc-item">
          <span class="desc-label">截止时间</span>
          <span class="desc-content">2025.11.25日上午10:30（北京时间）</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">提交地点</span>
          <span class="desc-content">连云港经济技术开发区黄海大道58号</span>
        </div>
      </div>
    </div>

    <!-- 开启 -->
    <div class="notice-section">
      <div class="section-title">五、开启</div>
      <div class="desc-container">
        <div class="desc-item">
          <span class="desc-label">开启时间</span>
          <span class="desc-content">2025.11.25日上午10:30（北京时间）</span>
        </div>
        <div class="desc-item">
          <span class="desc-label">开启地点</span>
          <span class="desc-content">连云港经济技术开发区黄海大道58号</span>
        </div>
      </div>
    </div>

    <!-- 其他补充事宜 -->
    <div class="notice-section">
      <div class="section-title">六、其他补充事宜</div>
      <div class="supplementary-content">无</div>
    </div>

    <!-- 联系方式 -->
    <div class="notice-section">
      <div class="section-title">八、凡对本次采购提出询问，请按以下方式联系</div>
      <div class="contact-container">
        <div class="contact-block">
          <div class="contact-title">1. 采购人信息</div>
          <ul class="contact-list">
            <li><span class="label">单位名称：</span>江苏海宏智能科技有限公司</li>
            <li><span class="label">单位地址：</span>连云港经济技术开发区黄海大道58号</li>
            <li><span class="label">联系人：</span>陈经理</li>
            <li><span class="label">联系电话：</span>15602484896</li>
          </ul>
        </div>

        <div class="contact-block">
          <div class="contact-title">2. 项目联系方式</div>
          <ul class="contact-list">
            <li><span class="label">联系人：</span>陈经理</li>
            <li><span class="label">联系电话：</span>15602484896</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BiddingNoticeDetail',
  components: {}
}
</script>

<style scoped>
/* 整体容器 */
.bidding-notice {
  width: 100%;
  max-width: 1200px;
  margin: 2rem auto;
  padding: 0 1rem;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", Arial, sans-serif;
}

/* 公告标题 */
.notice-title {
  font-size: 2rem;
  font-weight: bold;
  color: #1f2937;
  text-align: center;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

/* 发布时间标签 */
.publish-time {
  text-align: right;
  margin-bottom: 1rem;
}
.tag {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
}
.info-tag {
  background-color: #e8f4ff;
  color: #409eff;
  border: 1px solid #d9ecff;
}
.medium-tag {
  padding: 0.56rem 1rem;
  font-size: 16px;
}

/* 分隔线 */
.divider {
  height: 1px;
  background-color: #e6e6e6;
  margin: 1rem 0;
}

/* 章节标题 */
.section-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2563eb;
  margin: 1.5rem 0 1rem;
  padding-left: 0.5rem;
  border-left: 4px solid #2563eb;
}

/* 描述列表容器（替代el-descriptions） */
.desc-container {
  margin-top: 0.5rem;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
}
.desc-item {
  display: flex;
  border-bottom: 1px solid #ebeef5;
  font-size: 16px; /* 对应原size="large" */
}
.desc-item:last-child {
  border-bottom: none;
}
.desc-label {
  width: 180px;
  padding: 1rem;
  background-color: #f5f7fa;
  font-weight: 600;
  color: #374151;
  box-sizing: border-box;
  border-right: 1px solid #ebeef5;
}
.desc-content {
  flex: 1;
  padding: 1rem;
  color: #4b5563;
  box-sizing: border-box;
}

/* 资格要求列表 */
.qualification-list {
  margin: 1rem 0;
  padding-left: 1.5rem;
}
.qualification-subtitle {
  font-weight: 600;
  color: #374151;
  margin: 1rem 0 0.5rem;
}
.basic-qualification, .specific-qualification {
  margin: 0.5rem 0 1rem 1rem;
  color: #4b5563;
  line-height: 1.8;
}
.basic-qualification li, .specific-qualification li {
  margin-bottom: 0.5rem;
}

/* 补充事宜 */
.supplementary-content {
  color: #4b5563;
  padding: 0.5rem 1rem;
  background-color: #f9fafb;
  border-radius: 4px;
  margin-top: 0.5rem;
}

/* 联系方式容器 */
.contact-container {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}
.contact-block {
  flex: 1;
  min-width: 300px;
  background-color: #f9fafb;
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}
.contact-title {
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 1rem;
  font-size: 1.1rem;
}
.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.contact-list li {
  margin-bottom: 0.8rem;
  color: #4b5563;
  line-height: 1.6;
}
.contact-list .label {
  font-weight: 600;
  color: #374151;
  display: inline-block;
  width: 80px;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .notice-title {
    font-size: 1.5rem;
  }
  .section-title {
    font-size: 1.1rem;
  }
  .contact-container {
    flex-direction: column;
    gap: 1rem;
  }
  .desc-label {
    width: 120px;
    padding: 0.8rem;
    font-size: 14px;
  }
  .desc-content {
    padding: 0.8rem;
    font-size: 14px;
  }
}
</style>
